import {
  ItemRenderProps,
  TreeView,
  TreeViewExpandChangeEvent,
  TreeViewItemClickEvent,
} from "@progress/kendo-react-treeview";
import { useEffect, useState } from "react";
import { CustomersFileType } from "../Common/Types/types";

interface CustomerFilesProps {
  data: any | null;
    itemClick(path: any): void;
    source: string;
}

const CustomerFilesTreeView = (props: CustomerFilesProps) => {
  const [data, setData] = useState<CustomersFileType[]>([]);
  const [expand, setExpand] = useState(data);
  let selectedItem: any = undefined;

  const onExpandChange = (event: TreeViewExpandChangeEvent) => {
    event.item.expanded = !event.item.expanded;
    setExpand([...expand]);
    console.log(event);
    if (event.item.expanded && event.item.isFolder) {
      props.itemClick(event.item);
    }
  };
  const downloadFile = (fileUrl: string) => {
    const link = document.createElement("a");
   // console.log(fileUrl);
    link.href = fileUrl;
      //link.target = "_blank";
      link.download = ""; 
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

    const onItemClick = (event: TreeViewItemClickEvent) => {
        if (event.item.isFolder) {
            props.itemClick(event.item);
            return;
        }
        if (props.source === "sharepoint") {
            const encodedPath = encodeURIComponent(event.item.path);  
            if (event.item.path.includes("Electrical")) {
                downloadFile(`/api/sharepoint/downloadelectrical?path=${encodedPath}`);
            }
            else if (event.item.path.includes("retro")) {
                downloadFile(`/api/sharepoint/downloadretrofit?path=${encodedPath}`);
            }
            else {
                downloadFile(`/api/sharepoint/downloaddeliveries?path=${encodedPath}`);
            }
        }
        else {
            downloadFile(event.item.url);
        }
   

    //if (selectedItem) {
    //  selectedItem.selected = false;
    //}
    //event.item.selected = true;
    //selectedItem = event.item;

    //if (selectedItem.url == "" || selectedItem.url == null) {
    //  console.log(selectedItem.path);

    //  // for electrical
    //  downloadFile(
    //    "/api/sharepoint/downloadelectrical?path=" + selectedItem.path
    //  );

    //  // for retrofit
    //  /* downloadFile(
    //    "/api/sharepoint/downloadretrofit?path=" + selectedItem.path
    //  ); */
    //} else {
    //  //download item function
    //  if (!selectedItem.isFolder) {
    //    downloadFile(selectedItem.url);
    //  }
    //}
  };
  const MyItem = (props: ItemRenderProps) => {
    function iconClassName({ isFolder }) {
      if (isFolder) {
        return "k-icon k-i-folder";
      } else {
        return "k-icon k-i-file";
      }
    }
    return (
      <>
        <span className={iconClassName(props.item)} key="0" /> {props.item.text}
      </>
    );
  };

  useEffect(() => {
    if (props.data != null) {
      setData(props.data);
    }
  }, [props.data]);

  if (data == null) {
    return null; //<div>No data found for selected filters</div>;
  }
  return (
    <TreeView
      data={data}
      expandIcons={true}
      onExpandChange={onExpandChange}
      onItemClick={onItemClick}
      aria-multiselectable={false}
      item={MyItem}
    />
  );
};

export default CustomerFilesTreeView;
